export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7751.b47f801a.jpg";